import FieldConfig from "../../proto/field-config";
import FieldMultiselect from "../multiselect/multiselect";
import SessionCustomField from "../../../model2/custom-field/session-custom-field";
import {FieldType} from "../../field-type";
import FieldSkills_ManagementFormCFV1 from "./render/management/management-form-cfv1";
import CustomFieldsV1 from "../../../gd/const/fields/custom-fields-v1";
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups";
import FieldSkills_PopoverMenuMore from "./components/popover/popover-menu-more";

export default class FieldSkills extends FieldMultiselect {

    constructor(config: FieldConfig) {
        super(config);

        this.typeInteger    = CustomFieldsV1.type.SKILLS
        this.typeGroup      = GROUP_MISC
        this.typeLabel      = "Skills"
        this.icon           = "i5-skills-big"
        this.isSearchable   = true

        this.noValueOptionLabel      = _.get(config,'noValueOptionLabel','No skills')

        if (!config.options || config.options.length < 1) {

            this.options = []

            gd.company.settings.modules.skills.options.map((option: Option)=> {
                this.options!.push(option)
            })
        }

        this.components.PopoverMenuMore             = FieldSkills_PopoverMenuMore

        this.renderComponents.managementFormCFV1    = FieldSkills_ManagementFormCFV1
    }

    static initFromCustomFieldV1(customFieldV1:SessionCustomField) {
        return new FieldSkills({
            fieldId         : customFieldV1.id,
            label           : customFieldV1.name,
            type            : FieldType.SKILLS,
            fieldParams     : customFieldV1.params,
            fieldAccess     : customFieldV1.access
        })
    }
}
